/*测试用例与bug相关数据
 */
import { setSessionStore, removeSessionStore } from '@/utils/storage'
const app = {
    namespaced: true,
    state: {
        caseTypeData: [],
        bugTypeData: [],
    },

    mutations: {
        setCaseTypeData(state, data) {
            state.caseTypeData = data
        },
        setBugTypeData(state, data) {
            state.bugTypeData = data
        },
    },

    actions: {

    }
}

export default app
